import React from 'react';
import { useTranslation } from 'react-i18next';

import ProjectDetailPage from '../projects/projectdetail';
import { DetailContent } from '../global/styles/contentBlocks';

import parkBeanLogo from '../../images/park_bean_logo_name.svg';
import parkBeanHome from '../../images/park_bean_home-mobile.png';
import parkBeanSearch from '../../images/park_bean_search-mobile.png';
import parkBeanDetail from '../../images/park_bean_detail-mobile.png';
import parkBeanReport from '../../images/park_bean_report-mobile.png';

const SCREENSHOTS = [
  { img: parkBeanHome, titleKey: 'screenshotHomeTitle', descKey: 'screenshotHomeDesc' },
  { img: parkBeanSearch, titleKey: 'screenshotMapTitle', descKey: 'screenshotMapDesc' },
  { img: parkBeanDetail, titleKey: 'screenshotDetailTitle', descKey: 'screenshotDetailDesc' },
  { img: parkBeanReport, titleKey: 'screenshotReportTitle', descKey: 'screenshotReportDesc' },
];

function ParkBeanContent() {
  const [t] = useTranslation();
  const p = (key) => t(`ParkBeanDetailPage.${key}`);

  return (
    <DetailContent>
      {p('tagline')}
      <div className="section">
        <div className="sectiontitle">{p('overviewTitle')}</div>
        <p>{p('overview')}</p>
      </div>
      <div className="section">
        <div className="sectiontitle">{p('screenshotsTitle')}</div>
        <div className="screenshots">
          {SCREENSHOTS.map(({ img, titleKey, descKey }) => (
            <div className="screenshotcard" key={titleKey}>
              <img src={img} alt={p(titleKey)} />
              <div className="screenshotcaption">{p(titleKey)}</div>
              <div className="screenshotdesc">{p(descKey)}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="section">
        <div className="sectiontitle">{p('featuresTitle')}</div>
        <p>{p('features')}</p>
      </div>
      <div className="meta">
        <b>{p('timeCost')}</b>
        <br />
        <b>{p('skills')}</b>
      </div>
    </DetailContent>
  );
}

function ParkBeanPage() {
  const [t] = useTranslation();

  return (
    <ProjectDetailPage
      backHref="/startups"
      coverimg={parkBeanLogo}
      logoCover
      projectdetailname={t('ParkBeanDetailPage.name')}
      projectdetailshortdesc={t('StartupLandingPage.parkbeandes')}
      projectdetaildesc={<ParkBeanContent />}
      projectsite="https://parkbean.com"
      visitLabelKey="ParkBeanDetailPage.visit"
    />
  );
}

export default ParkBeanPage;
